import React, { useEffect, useState } from 'react'
import useTextAnimation from './helpers/animateText'
import { TEXT_PROPS } from './interface'
import { TextWrapper } from './TextStyles'

function Text({ text, gameState, noAnimate, betReply, dealOut }: TEXT_PROPS) {
  const [content, setContent] = useState<string>(text)
  const [fadeOut, setFadeOut] = useState<boolean>(false)

  useTextAnimation(text, setFadeOut, setContent, gameState)

  useEffect(() => {
    dealOut && setFadeOut(true)
  }, [dealOut])
  return (
    <div style={{ height: '15px' }}>
      <TextWrapper fadeOut={fadeOut} noAnimate={noAnimate} betReply={betReply}>
        {content}
      </TextWrapper>
    </div>
  )
}

export default Text
